<script>
  import PrimaryBorderedButton from "../../../../components/button/generic/PrimaryBorderedButton.svelte";
  import ApplyMagicnumberDialog from "./ApplyMagicnumberDialog.svelte";
  import Subsection from "../../../../components/layout/Subsection.svelte";
  import SubsectionTitle from "../../../../components/layout/SubsectionTitle.svelte";
  import { translate } from "../../../../i18n/i18next.js";

  let isDialogOpen = false
</script>

<Subsection>
  <SubsectionTitle>
    {translate("frontend:components.manageLicenseAuthenticationDialog.eProtector.update.title")}
  </SubsectionTitle>
  <div class="subsection-content-caption">
    {translate("frontend:components.manageLicenseAuthenticationDialog.eProtector.update.caption")}
  </div>
  <div class="subsection-content-button">
    <PrimaryBorderedButton onClick={() => isDialogOpen = true}>
      {translate("frontend:components.manageLicenseAuthenticationDialog.eProtector.update.magicnumber.label")}
    </PrimaryBorderedButton>
  </div>
  {#if isDialogOpen}
    <ApplyMagicnumberDialog onClose={() => isDialogOpen = false}/>
  {/if}
</Subsection>

<style>
  .subsection-content-button {
    align-self: end;
  }
</style>
